"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _DropdownOptions = _interopRequireDefault(require("@airasia/phoenix-components/components/DropdownOptions"));

var _Modal = _interopRequireDefault(require("@airasia/phoenix-components/components/Modal"));

var _SectionTileGroup = _interopRequireDefault(require("@airasia/phoenix-components/components/SectionTileGroup"));

var _utilities = _interopRequireDefault(require("../../utilities"));

var _localeCurrency = _interopRequireDefault(require("./localeCurrency.proptypes"));

var _constant = require("./constant");

var _localeCurrency2 = _interopRequireDefault(require("./localeCurrency.util"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var LocaleCurrencyWrapper = _styledComponents.default.div.withConfig({
  displayName: "LocaleCurrency__LocaleCurrencyWrapper",
  componentId: "sc-17lkucc-0"
})([""]);

var RecommendedWrapper = _styledComponents.default.div.withConfig({
  displayName: "LocaleCurrency__RecommendedWrapper",
  componentId: "sc-17lkucc-1"
})(["margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.semiLarge;
});

var LocaleCurrency = function LocaleCurrency(props) {
  var defaultCurrency = props.defaultCurrency,
      defaultLocale = props.defaultLocale,
      currencyList = props.currencyList,
      localeList = props.localeList,
      recommendedCurrencyList = props.recommendedCurrencyList,
      recommendedLocaleList = props.recommendedLocaleList,
      labelConfig = props.labelConfig,
      onLocaleChange = props.onLocaleChange,
      onCurrencyChange = props.onCurrencyChange,
      icon = props.icon,
      dropdownPosition = props.dropdownPosition,
      showCurrency = props.showCurrency,
      showLocale = props.showLocale,
      dropdownConfig = props.dropdownConfig,
      modalConfig = props.modalConfig,
      sectionConfig = props.sectionConfig,
      device = props.device,
      accessible = props.accessible,
      customProperties = props.customProperties,
      theme = props.theme,
      fireGtm = props.fireGtm,
      gtmLocaleEventData = props.gtmLocaleEventData,
      gtmCurrencyEventData = props.gtmCurrencyEventData,
      move = props.move;
  var combinedLocaleList = recommendedLocaleList ? [].concat((0, _toConsumableArray2.default)(recommendedLocaleList), (0, _toConsumableArray2.default)(localeList)) : localeList;
  var combinedCurrencyList = recommendedCurrencyList ? [].concat((0, _toConsumableArray2.default)(recommendedCurrencyList), (0, _toConsumableArray2.default)(currencyList)) : currencyList;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)(_localeCurrency2.default.getSingleLocaleDefault(combinedLocaleList, defaultLocale)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      defaultLocaleState = _useState2[0],
      setDefaultLocaleState = _useState2[1];

  var _useState3 = (0, _react.useState)(_localeCurrency2.default.getSingleCurrencyShortform(combinedCurrencyList, defaultCurrency)),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      defaultCurrencyState = _useState4[0],
      setDefaultCurrencyState = _useState4[1];
  /** States for DropdownOptions Component */


  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      selectedLocaleObj = _useState6[0],
      setSelectedLocaleObj = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      selectedCurrencyObj = _useState8[0],
      setSelectedCurrencyObj = _useState8[1];

  var _useState9 = (0, _react.useState)(_localeCurrency2.default.getLocaleByDefault(defaultLocaleState, combinedLocaleList).shortform.toUpperCase()),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      localeHeader = _useState10[0],
      setLocaleHeader = _useState10[1];

  var _useState11 = (0, _react.useState)(_localeCurrency2.default.getCurrencyByShortform(defaultCurrencyState, combinedCurrencyList).shortform.toUpperCase()),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      currencyHeader = _useState12[0],
      setCurrencyHeader = _useState12[1];

  var _useState13 = (0, _react.useState)([]),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      dropdownOptionsData = _useState14[0],
      setDropdownOptionsData = _useState14[1];

  var _useState15 = (0, _react.useState)(null),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      selectedOption = _useState16[0],
      setSelectedOption = _useState16[1];
  /** States for Section Tile Group Component */


  var _useState17 = (0, _react.useState)([]),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      localeTileData = _useState18[0],
      setLocaleTileData = _useState18[1];

  var _useState19 = (0, _react.useState)([]),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      currencyTileData = _useState20[0],
      setCurrencyTileData = _useState20[1];

  var _useState21 = (0, _react.useState)(null),
      _useState22 = (0, _slicedToArray2.default)(_useState21, 2),
      recLocaleTileData = _useState22[0],
      setRecLocaleTileData = _useState22[1];

  var _useState23 = (0, _react.useState)(null),
      _useState24 = (0, _slicedToArray2.default)(_useState23, 2),
      recCurrencyTileData = _useState24[0],
      setRecCurrencyTileData = _useState24[1];

  var _useState25 = (0, _react.useState)({
    locale: defaultLocaleState,
    currency: defaultCurrencyState
  }),
      _useState26 = (0, _slicedToArray2.default)(_useState25, 2),
      selectedLocaleCurrency = _useState26[0],
      setSelectedLocaleCurrency = _useState26[1];

  var popularLocale = labelConfig.popularLocale,
      otherLocale = labelConfig.otherLocale,
      locale = labelConfig.locale,
      popularCurrency = labelConfig.popularCurrency,
      otherCurrency = labelConfig.otherCurrency,
      currency = labelConfig.currency;
  (0, _react.useEffect)(function () {
    setDefaultLocaleState(_localeCurrency2.default.getSingleLocaleDefault(combinedLocaleList, defaultLocale));
  }, [defaultLocale, combinedLocaleList]);
  (0, _react.useEffect)(function () {
    var localeObj = _localeCurrency2.default.getLocaleByDefault(defaultLocaleState, combinedLocaleList);

    setSelectedLocaleObj(localeObj);
    setLocaleHeader(localeObj.shortform.toUpperCase());
    setSelectedLocaleCurrency(_objectSpread(_objectSpread({}, selectedLocaleCurrency), {}, {
      locale: localeObj.default
    })); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLocaleState]);
  (0, _react.useEffect)(function () {
    setDefaultCurrencyState(_localeCurrency2.default.getSingleCurrencyShortform(combinedCurrencyList, defaultCurrency));
  }, [defaultCurrency, combinedCurrencyList]);
  (0, _react.useEffect)(function () {
    var currencyObj = _localeCurrency2.default.getCurrencyByShortform(defaultCurrencyState, combinedCurrencyList);

    setSelectedCurrencyObj(currencyObj);
    setCurrencyHeader(currencyObj.shortform.toUpperCase());
    setSelectedLocaleCurrency(_objectSpread(_objectSpread({}, selectedLocaleCurrency), {}, {
      currency: currencyObj.shortform
    })); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultCurrencyState]);
  (0, _react.useEffect)(function () {
    setCurrencyTileData(_localeCurrency2.default.generateCurrencyList(currencyList));
    setLocaleTileData(_localeCurrency2.default.generateLocaleList(localeList));

    if (recommendedLocaleList && recommendedLocaleList.length > 0) {
      setRecLocaleTileData(_localeCurrency2.default.generateLocaleList(recommendedLocaleList));
    } else {
      setRecLocaleTileData(null);
    }

    if (recommendedCurrencyList && recommendedCurrencyList.length > 0) {
      setRecCurrencyTileData(_localeCurrency2.default.generateCurrencyList(recommendedCurrencyList));
    } else {
      setRecCurrencyTileData(null);
    }
  }, [currencyList, localeList, recommendedLocaleList, recommendedCurrencyList]);
  (0, _react.useEffect)(function () {
    setDropdownOptionsData(_localeCurrency2.default.generateDropdownOptionsData(selectedLocaleObj, selectedCurrencyObj, showLocale, showCurrency, combinedLocaleList, combinedCurrencyList)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocaleObj, selectedCurrencyObj, showLocale, showCurrency]);
  /**
   * Close Modal
   */

  var onModalCloseHandler = function onModalCloseHandler() {
    setSelectedOption(null);
  };

  var onOptionSelectHandler = function onOptionSelectHandler(val) {
    setSelectedOption(val);
  };
  /**
   *
   * @param {string} val selected locale
   *
   * Handle locale selection
   */


  var onLocaleSelectHandler = function onLocaleSelectHandler(val) {
    setSelectedLocaleCurrency(_objectSpread(_objectSpread({}, selectedLocaleCurrency), {}, {
      locale: val
    }));

    if (onLocaleChange) {
      onLocaleChange(val);
    }

    if (fireGtm && gtmLocaleEventData) {
      var oldLocale = _utilities.default.getLocaleCode(selectedLocaleCurrency.locale);

      var newLocale = _utilities.default.getLocaleCode(val);

      var newData = gtmLocaleEventData.replace('{{oldlocale}}', oldLocale).replace('{{newlocale}}', newLocale);
      fireGtm(newData);
    }

    var localeObj = _localeCurrency2.default.getLocaleByDefault(val, combinedLocaleList);

    setLocaleHeader(localeObj.shortform.toUpperCase());
    setSelectedLocaleObj(localeObj);
    onModalCloseHandler();
  };
  /**
   *
   * @param {string} val selected currency
   *
   * Handle currency selection
   */


  var onCurrencySelectHandler = function onCurrencySelectHandler(val) {
    setSelectedLocaleCurrency(_objectSpread(_objectSpread({}, selectedLocaleCurrency), {}, {
      currency: val
    }));

    if (onCurrencyChange) {
      onCurrencyChange(val);
    }

    if (fireGtm && gtmCurrencyEventData) {
      var newData = gtmCurrencyEventData.replace('{{oldcurrency}}', selectedLocaleCurrency.currency.toLowerCase()).replace('{{newcurrency}}', val.toLowerCase());
      fireGtm(newData);
    }

    var currencyObj = _localeCurrency2.default.getCurrencyByShortform(val, combinedCurrencyList);

    setCurrencyHeader(currencyObj.shortform.toUpperCase());
    setSelectedCurrencyObj(currencyObj);
    onModalCloseHandler();
  };

  var localeModal = function localeModal() {
    var defaultLocaleLabel = recLocaleTileData ? otherLocale : locale;
    return /*#__PURE__*/_react.default.createElement(_Modal.default, (0, _extends2.default)({
      openModal: selectedOption === _constant.DROPDOWN_VALUES.LOCALE,
      theme: theme,
      viewPort: device,
      accessible: accessible,
      onClose: onModalCloseHandler,
      customProperties: {
        id: 'airasia-locale-currency-widget-locale-modal'
      }
    }, modalConfig, {
      move: move
    }), recLocaleTileData && /*#__PURE__*/_react.default.createElement(RecommendedWrapper, null, /*#__PURE__*/_react.default.createElement(_SectionTileGroup.default, (0, _extends2.default)({
      accessible: accessible,
      data: recLocaleTileData,
      theme: theme,
      title: popularLocale,
      onClick: onLocaleSelectHandler,
      defaultSelectedData: selectedLocaleCurrency.locale,
      customProperties: {
        id: 'airasia-locale-currency-widget-suggested-locale'
      }
    }, sectionConfig, {
      move: move
    }))), /*#__PURE__*/_react.default.createElement(_SectionTileGroup.default, (0, _extends2.default)({
      accessible: accessible,
      data: localeTileData,
      theme: theme,
      title: defaultLocaleLabel,
      onClick: onLocaleSelectHandler,
      defaultSelectedData: selectedLocaleCurrency.locale,
      customProperties: {
        id: 'airasia-locale-currency-widget-locale-list'
      }
    }, sectionConfig, {
      move: move
    })));
  };

  var currencyModal = function currencyModal() {
    var defaultCurrencyLabel = recCurrencyTileData ? otherCurrency : currency;
    return /*#__PURE__*/_react.default.createElement(_Modal.default, (0, _extends2.default)({
      openModal: selectedOption === _constant.DROPDOWN_VALUES.CURRENCY,
      theme: theme,
      viewPort: device,
      accessible: accessible,
      onClose: onModalCloseHandler,
      customProperties: {
        id: 'airasia-locale-currency-widget-currency-modal',
        'aria-label': 'Currency'
      }
    }, modalConfig, {
      move: move
    }), recCurrencyTileData && /*#__PURE__*/_react.default.createElement(RecommendedWrapper, null, /*#__PURE__*/_react.default.createElement(_SectionTileGroup.default, (0, _extends2.default)({
      accessible: accessible,
      data: recCurrencyTileData,
      theme: theme,
      title: popularCurrency,
      onClick: onCurrencySelectHandler,
      defaultSelectedData: selectedLocaleCurrency.currency,
      customProperties: {
        id: 'airasia-locale-currency-widget-suggested-currency'
      }
    }, sectionConfig, {
      move: move
    }))), /*#__PURE__*/_react.default.createElement(_SectionTileGroup.default, (0, _extends2.default)({
      accessible: accessible,
      data: currencyTileData,
      theme: theme,
      title: defaultCurrencyLabel,
      onClick: onCurrencySelectHandler,
      defaultSelectedData: selectedLocaleCurrency.currency,
      customProperties: {
        id: 'airasia-locale-currency-widget-currency-list'
      }
    }, sectionConfig, {
      move: move
    })));
  };

  var generateHeaderLabel = function generateHeaderLabel() {
    var header = "".concat(localeHeader, " / ").concat(currencyHeader);

    if (!showLocale) {
      header = "".concat(currencyHeader);
    }

    if (!showCurrency) {
      header = "".concat(localeHeader);
    }

    return header;
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(LocaleCurrencyWrapper, (0, _extends2.default)({
      id: "airasia-locale-currency-widget"
    }, customProperties), /*#__PURE__*/_react.default.createElement(_DropdownOptions.default, (0, _extends2.default)({
      headerIcon: icon,
      headerLabel: generateHeaderLabel(),
      data: dropdownOptionsData,
      onOptionSelect: onOptionSelectHandler,
      dropdownPosition: dropdownPosition,
      accessible: accessible,
      theme: theme
    }, dropdownConfig, {
      customProperties: {
        'aria-label': "Language and Currency selector. Chosen language is ".concat(selectedLocaleObj && selectedLocaleObj.longform, ". Chosen currency is ").concat(selectedCurrencyObj && selectedCurrencyObj.longform, ". Actionable Left click or press enter to edit your preference."),
        'aria-live': 'assertive'
      },
      optionsCustomProperties: {
        'aria-label': 'Language and Currency'
      },
      move: move
    })), showCurrency && currencyModal(), showLocale && localeModal());
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

LocaleCurrency.propTypes = _localeCurrency.default.PropTypes;
LocaleCurrency.defaultProps = _localeCurrency.default.DefaultProps;
var _default = LocaleCurrency;
exports.default = _default;